module.exports = __webpack_public_path__ + "img/OFFAlgorithm.f4f7bb5b.png";